var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// components/ge-grid.ts
import { ElementsGrid } from "@adornis/chemistry/elements/components/x-grid";
import { customElement } from "lit/decorators.js";
var GermaniumGrid = class extends ElementsGrid {
};
GermaniumGrid = __decorateClass([
  customElement("ge-grid")
], GermaniumGrid);
export {
  GermaniumGrid
};
